/**
 * @typedef {import('../../util/custom.js').ElementOriginalUrlObject} ElementOriginalUrlObject
 */

import { getElementUrl, setElementUrl } from '../../util/custom.js';

/**
	 * @param {Array.<[HTMLElement, ElementOriginalUrlObject]>} items
	 */
// eslint-disable-next-line unicorn/consistent-function-scoping
const doReplaceBulk = (items) => {
	for (const [elem, obj] of items) {

		let tableRow;
		let urlHash = '';
		let returnHash = '';

		// Element has a hash in the url
		if (obj.url.includes('#')) {
			urlHash = obj.url.slice(Math.max(0, obj.url.indexOf('#')));
		}

		// Element is inside a table row and does NOT have a hash in the url
		if ((obj.attrName === 'href') && (tableRow = elem.closest('tr[id^="row-"]'))) {
			// Add the table row id to the url hash so we can scroll to it after the page reload
			returnHash = '#' + tableRow.id;
		}

		obj.url = obj.url.replace(/return=[^&]+/, 'return=' + encodeURIComponent(window.location.pathname + window.location.search + returnHash) + urlHash);
		setElementUrl(elem, obj.url, obj);
	}
};

/**
 * Auto-Replace return param
 *
 * @type {DynamicInitFunction<HTMLElement>}
 */
export default ($collection) => {

	// let items = 0;
	let currentBulk = [];
	const maxBulk = 10;

	for (const elem of $collection) {
		const obj = getElementUrl(elem, false);
		if (obj.url && /[&?]return=self/.test(obj.url)) {
			// items++;
			currentBulk.push([elem, obj]);

			// Bulk replace with timeout
			if (currentBulk.length >= maxBulk) {
				window.setTimeout(doReplaceBulk, void 0, currentBulk);
				currentBulk = [];
			}
		}
	}

	// We still have some items to replace
	if (currentBulk.length > 0) {
		window.setTimeout(doReplaceBulk, void 0, currentBulk);
		currentBulk = [];
	}
};